import React, { useState } from "react"
import emailjs from "@emailjs/browser"
import { toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import "./css/Header.css"
import "./css/WorkWithUs.css"
import img0748 from "../assets/IMG_0748.jpg"
import img103 from "../assets/103-cat.jpg"

const WorkWithUs = () => {
  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [phone, setPhone] = useState("")
  const [message, setmessage] = useState("")

  function clearAll() {
    setName("")
    setEmail("")
    setPhone("")
    setmessage("")
  }

  function sendEmail(e) {
    e.preventDefault()
    const templateParams = {
      from_name: name,
      from_email: email,
      from_phone: phone,
      from_message: message
    }

    emailjs.send("service_er4ays4", "template_gdyf0w7", templateParams, "GO4Kel1r7PXEJaM0e").then(
      result => {
        toast.success("Enquiry sent successfully!")
        clearAll()
      },
      error => {
        console.error("Error sending email:", error.text)
        toast.error("An error occurred while sending your enquiry. Email us at info@jambotreekenya.com")
      }
    )
  }

  return (
    <div className="work-with-us-page">
      {/* Page Header */}
      <section className="page-header">
        <div className="container">
          <div className="header-content">
            <h1 className="page-title">Work With Us</h1>
            <p className="page-subtitle">
              Partner with us to create positive environmental impact and support Kenya's climate action goals
            </p>
          </div>
        </div>
      </section>

      {/* Mission & Values */}
      <section className="mission-section">
        <div className="container">
          <div className="mission-content">
            <div className="mission-text">
              <h2 className="section-title">Our Mission</h2>
              <div className="title-underline"></div>
              <p className="mission-description">
                Jambo Tree Kenya is an ethical business that aims to create jobs for the local community, particularly women, young mothers, youth and disabled people. We are committed to ensuring that local communities make informed choices before we engage in activities that impact their rights, survival, dignity and well-being, and protect local communities from Biopiracy.
              </p>
              <div className="values-highlight">
                <h4>🌍 UN Declaration Compliant</h4>
                <p>The way we work upholds the United Nations Declaration on the Rights of Indigenous Peoples (UNDRIP).</p>
              </div>
            </div>
            
            <div className="mission-images">
              <div className="image-gallery">
                <img src={img0748} alt="Jambo Tree Kenya community work" className="gallery-image" />
                <img src={img103} alt="Jambo Tree Kenya team" className="gallery-image" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Partnership Opportunities */}
      <section className="partnership-section">
        <div className="container">
          <h2 className="section-title">Partnership Opportunities</h2>
          <div className="title-underline"></div>
          
          <div className="partnership-intro">
            <p className="intro-text">
              Jambo Tree Kenya would like to work with land owners, organisations and individuals that share our values and want to make a positive environmental impact by donating funding towards tree planting, reforesting, investing in community resilience and supporting Kenya's Climate Action goals.
            </p>
            <div className="climate-goal">
              <h4>🎯 Climate Target</h4>
              <p>We're developing plans to generate income from Carbon Offsetting by planting and caring for trees on their land and in-turn support Kenyan Government reforesting targets of 30% cover by 2030.</p>
            </div>
          </div>

          <div className="partnership-types">
            <div className="partnership-card">
              <div className="card-header">
                <h3>🌳 For Land Owners</h3>
                <p>We will work with you to:</p>
              </div>
              <div className="card-content">
                <ul className="service-list">
                  <li>Select suitable species for soil and other conditions</li>
                  <li>Provide seeds and seedlings</li>
                  <li>Support site preparation and tree planting or carry out the site preparation and tree planting</li>
                  <li>Training with after care to establish the trees</li>
                </ul>
              </div>
            </div>

            <div className="partnership-card">
              <div className="card-header">
                <h3>🏢 For Companies & Community Groups</h3>
                <p>We will help:</p>
              </div>
              <div className="card-content">
                <ul className="service-list">
                  <li>Corporate teams who want to support tree planting as part of their Corporate Social Responsibility (CSR) and business model, and Offset their CO2 emissions</li>
                  <li>Support community groups to plan, manage planting activities and care for trees</li>
                  <li>Individuals and families who want to plant trees in their local area</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="contact-form-section">
        <div className="container">
          <div className="form-container">
            <div className="form-header">
              <h2 className="section-title">Get In Touch</h2>
              <div className="title-underline"></div>
              <p className="form-description">
                If you would like to discuss working with us please complete the following enquiry form.
              </p>
            </div>
            
            <form onSubmit={sendEmail} className="contact-form">
              <div className="form-grid">
                <div className="form-group">
                  <label htmlFor="name" className="form-label">Name *</label>
                  <input 
                    type="text" 
                    id="name" 
                    className="form-input" 
                    value={name} 
                    onChange={e => setName(e.target.value)} 
                    required
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="email" className="form-label">Email *</label>
                  <input 
                    type="email" 
                    id="email" 
                    className="form-input" 
                    value={email} 
                    onChange={e => setEmail(e.target.value)} 
                    required
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="phone" className="form-label">Phone</label>
                  <input 
                    type="tel" 
                    id="phone" 
                    className="form-input" 
                    value={phone} 
                    onChange={e => setPhone(e.target.value)} 
                  />
                </div>
              </div>
              
              <div className="form-group">
                <label htmlFor="message" className="form-label">Message *</label>
                <textarea 
                  id="message" 
                  className="form-textarea" 
                  rows={6} 
                  value={message} 
                  onChange={e => setmessage(e.target.value)}
                  required
                ></textarea>
              </div>
              
              <div className="form-submit">
                <button type="submit" className="btn btn-primary submit-btn">
                  Send Enquiry
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>

      {/* Contact Information */}
      <section className="contact-info-section">
        <div className="container">
          <div className="contact-info-content">
            <div className="contact-card">
              <h3>📧 Email</h3>
              <p>info@jambotreekenya.com</p>
            </div>
            <div className="contact-card">
              <h3>📞 Phone</h3>
              <p>+254 705 682 012</p>
            </div>
            <div className="contact-card">
              <h3>🌐 Website</h3>
              <p>www.jambotreekenya.com</p>
            </div>
            <div className="contact-card">
              <h3>📍 Location</h3>
              <p>Jambo Tree Limited<br />Nairobi, Kenya</p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="work-cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Make a Difference?</h2>
            <p>Join us in creating a sustainable future for Africa. Together, we can build a climate-resilient ecosystem.</p>
            <div className="cta-buttons">
              <a href="/about" className="btn btn-secondary">Learn More About Us</a>
              <a href="/products" className="btn btn-outline">View Our Products</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default WorkWithUs